import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import React from "react";
import LazyLoad from "react-lazyload";
import { Link } from "react-router-dom";
import { getPublicPrice } from "../../utils/weightUtils";
import ProductAddToBasket from "../products/ProductAddToBasket";
import "./Catalogus.scss";

function PublicCatalogus(props) {
  return (
    <Grid container justifyContent="center" alignItems="flex-start" spacing={3}>
      {props.data.map((rowData) => (
        <LazyLoad placeholder="Loading">
          <Grid item xs={12}>
            <div className="photoDiv">
              <Link
                style={{ textDecoration: "none" }}
                to={{
                  pathname: "/productinfo",
                  state: { from: rowData.id },
                }}
              >
                {rowData.image ? (
                  <img className="photo" src={rowData.image}></img>
                ) : null}
              </Link>
              <div className="textAndButton">
                <Link
                  style={{ textDecoration: "none" }}
                  to={{
                    pathname: "/productinfo",
                    state: { from: rowData.id },
                  }}
                >
                  {rowData.bio ? (
                    <div>
                      <p className="productName">{rowData.name}</p>{" "}
                      <img
                        className="bio"
                        src={
                          "https://www.goeieete.nl/wp-content/themes/goeieete/assets/logo-bio.svg"
                        }
                      />
                    </div>
                  ) : (
                    <p className="productName">{rowData.name}</p>
                  )}
                </Link>
                <Link
                  style={{ textDecoration: "none", color: "black" }}
                  to={{
                    pathname: "/supplierinfo",
                    state: { from: rowData.supplier_id },
                  }}
                >
                  <p1 className="supplierName">{rowData.supplier_name}</p1>
                  <br />
                </Link>
                <Typography
                  component="span"
                  variant="body2"
                  className="inline"
                  color="textPrimary"
                >
                  {getPublicPrice(rowData)}
                </Typography>

                <br />
                <br />

                {props.loginSuccesful ? (
                  <div>
                    <ProductAddToBasket
                      productId={rowData.id}
                      rowData={rowData}
                      screenType="Assortiment"
                    />
                  </div>
                ) : null}
                <br />
                <Divider variant="inset" />
              </div>
            </div>
          </Grid>
        </LazyLoad>
      ))}
    </Grid>
  );
}

export default PublicCatalogus;
